import { Link } from "@mui/material";
import React from "react";

type LogoProps = {
  logo: string;
  url: string;
};

export const Logo = ({ logo, url }: LogoProps) => {
  return (
    <Link
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      sx={{
        m: 1,
        width: { xs: 64, sm: 80 },
        height: { xs: 64, sm: 80 },
        borderRadius: "16px",
        boxShadow: 3,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        overflow: "hidden",
        flexShrink: 0,
        "&:hover": {
          transform: "scale(1.03)",
        },
        transition: "all 0.2s ease-in-out",
      }}
    >
      <img
        alt={`${url} logo`}
        src={logo}
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          borderRadius: "16px",
          userSelect: "none",
          pointerEvents: "none",
        }}
        draggable={false}
      />
    </Link>
  );
};
